import { CarrierGroup, PlanBotTriggerSource } from './api/fetch-carrier-api'

// Shared with the backend's PLAN_MANAGEMENT_MAX_UPLOAD_FILE_BYTES.
export const MAX_UPLOAD_FILE_SIZE_BYTES = 50 * 1024 * 1024

export const CARRIER_GROUP_LABELS: Partial<Record<CarrierGroup, string>> = {
  [CarrierGroup.FLORIDA_BLUE]: 'Florida Blue',
  [CarrierGroup.HARVARD_PILGRIM]: 'Harvard Pilgrim',
}

export const TRIGGER_SOURCE_LABELS: Record<PlanBotTriggerSource, string> = {
  [PlanBotTriggerSource.MANUAL]: 'Manual',
  [PlanBotTriggerSource.SCHEDULER]: 'Scheduler',
}

export function formatTriggerSource(
  value: PlanBotTriggerSource | string | null | undefined
): string {
  if (!value) return '—'
  return TRIGGER_SOURCE_LABELS[value as PlanBotTriggerSource] ?? value
}

export function formatTriggeredBy(value: string | null | undefined): string {
  if (!value || value.toUpperCase() === 'SYSTEM') return 'System'
  return value
}

export const CARRIER_GROUP_OPTIONS = Object.values(CarrierGroup).map((v) => ({
  value: v,
  label: CARRIER_GROUP_LABELS[v] ?? v,
}))

export type SurecoCsvDataType =
  | 'LOCATION'
  | 'SMOKER_RATES'
  | 'SERVICE_AREAS'
  | 'PLANS_AND_RATES'
  | 'PLAN_BENEFITS'

export const SURECO_CSV_DATA_TYPE_OPTIONS: {
  label: string
  value: SurecoCsvDataType
}[] = [
  { label: 'Location', value: 'LOCATION' },
  { label: 'Smoker Rates', value: 'SMOKER_RATES' },
  { label: 'Service Areas', value: 'SERVICE_AREAS' },
  { label: 'Plans & Rates', value: 'PLANS_AND_RATES' },
  { label: 'Plan Benefits', value: 'PLAN_BENEFITS' },
]

export type DownloadableSurecoCsvDataType = SurecoCsvDataType | 'SBC_LINKS'

export const DOWNLOADABLE_SURECO_CSV_DATA_TYPE_OPTIONS: {
  label: string
  value: DownloadableSurecoCsvDataType
}[] = [
  ...SURECO_CSV_DATA_TYPE_OPTIONS,
  { label: 'SBC Links', value: 'SBC_LINKS' },
]

export function dataTypeLabel(dataType: SurecoCsvDataType): string {
  return (
    SURECO_CSV_DATA_TYPE_OPTIONS.find((o) => o.value === dataType)?.label ??
    dataType
  )
}

export type PlanReportType =
  | 'PLAN_CHANGE_IMPACT'
  | 'SERVICE_AREA_MISMATCH'
  | 'MISSING_RATING_AREA_PRICE'
  | 'MISSING_BENEFIT'
  | 'MISSING_SBC'
  | 'COUNTY_MISMATCH'

export const PLAN_REPORT_TYPE_OPTIONS: {
  label: string
  value: PlanReportType
}[] = [
  { label: 'Plan Change Impact', value: 'PLAN_CHANGE_IMPACT' },
  { label: 'Service Area Mismatch', value: 'SERVICE_AREA_MISMATCH' },
  {
    label: 'Missing Rating-Area Price',
    value: 'MISSING_RATING_AREA_PRICE',
  },
  { label: 'Missing Benefits', value: 'MISSING_BENEFIT' },
  { label: 'Missing SBC', value: 'MISSING_SBC' },
  { label: 'County Mismatch', value: 'COUNTY_MISMATCH' },
]
